import Swimlane from "../../../components/swimlane";
import React from "react";
import CategoryHead from "../../../components/categoryhead";
import styled from "styled-components";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import {
  styledMedia,
  withAllMatches
} from "../../../components/mediaquery/breakpoints";
import CenteredSpinner from "../../../components/spinner/centered-spinner";
import createScrollAction from "../../../components/swimlane/create-scroll-action";
import AccessibleSkipButton from "../../../components/accessible-skip-button";
import { t } from "../../../core/translate";
import PromotionElement from "./promotion-element";
import {
  PROMOTION_TOTAL_HEIGHT,
  PROMOTION_TOTAL_WIDTH
} from "./promotionConsts";
import { connect } from "react-redux";

const EDGE_SPACING = 38;
const EDGE_SPACING_MED = 16;

const ITEM_SPACING = 17;
const ITEM_SPACING_MED = 12;
const ITEM_SPACING_SM = 4;

const CARD_WIDTH_MED = 170;
const CARD_HEIGHT_MED = 244;
// only use regular size cards in grid, and reduce number of cards per row to fit
const CARD_WIDTH_SM = 170;
const CARD_HEIGHT_SM = 244;

const Container = styled.div`
  margin-bottom: 20px;
`;

export const HeadContainer = styled.h2`
  font-weight: 400;
  margin-bottom: 23px;
  /* 18px to accomodate Button padding alignment. */
  padding: 0 ${EDGE_SPACING}px 0 18px;
  ${p => p.grid && `margin-top: 49px;`}
  ${styledMedia.medium`
    padding: 0;
  `};
  ${styledMedia.small`
    margin-top: 18px;
    margin-bottom: 22px;
  `};
`;

const LoadingBlock = styled.div`
  margin: 0 ${EDGE_SPACING}px 30px;
  height: ${PROMOTION_TOTAL_HEIGHT}px;
  background-color: white;

  ${styledMedia.medium`
    margin: 0 ${EDGE_SPACING_MED}px 30px;
    height: ${CARD_HEIGHT_MED}px;
  `};
  ${styledMedia.small`
    height: ${CARD_HEIGHT_SM}px;
  `};
`;

function getStyles(isMedium, isSmall) {
  let itemSpacing = ITEM_SPACING;
  let edgeSpacing = EDGE_SPACING;

  if (isMedium) {
    itemSpacing = ITEM_SPACING_MED;
    edgeSpacing = EDGE_SPACING_MED;
  }

  if (isSmall) {
    itemSpacing = ITEM_SPACING_SM;
  }

  return {
    base: {
      marginLeft: itemSpacing,
      marginRight: itemSpacing
    },
    first: {
      marginLeft: edgeSpacing,
      marginRight: itemSpacing
    },
    last: {
      marginLeft: itemSpacing,
      marginRight: edgeSpacing
    }
  };
}

function PromotionSwimlane({
  onHeaderClick,
  isMedium,
  isSmall,
  tryLoadMore = () => {},
  backArrow,
  promotions = []
}) {
  const count = promotions.length;

  function getStyle(i) {
    const style = getStyles(isMedium, isSmall);

    if (i === 0) {
      return style.first;
    } else if (i === count - 1) {
      return style.last;
    }
    return style.base;
  }

  function renderPromotion({ i }) {
    const { value, title, description, cover, active, type } = promotions[i];
    return (
      <li key={value} style={getStyle(i)}>
        <PromotionElement
          value={value}
          title={title}
          description={description}
          cover={cover}
          active={active}
          type={type}
        />
      </li>
    );
  }

  function getAverageItemWidth() {
    if (isSmall) {
      return CARD_WIDTH_SM + ITEM_SPACING_SM * 2;
    }
    if (isMedium) {
      return CARD_WIDTH_MED + ITEM_SPACING_MED * 2;
    }
    return PROMOTION_TOTAL_WIDTH + ITEM_SPACING * 2;
  }

  const handleScroll = createScrollAction(tryLoadMore);
  let skipAheadRef = null;
  let skipBackRef = null;

  function skipAheadClick() {
    skipAheadRef.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
    //Focus added here with preventScroll to actually focus on element
    skipAheadRef.focus({ preventScroll: true });
  }

  function skipBackClick() {
    skipBackRef.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
    //Focus added here with preventScroll to actually focus on element
    skipBackRef.focus({ preventScroll: true });
  }

  if (count) {
    return (
      <Container>
        <HeadContainer>
          <CategoryHead
            count={count}
            hideCount
            onClick={count >= 5 && onHeaderClick}
            label={t("promotions.shortcuts", "Shortcuts")}
            caretRight={count >= 5}
            backArrow={backArrow}
            skipAhead={count >= 1}
            skipAheadClick={skipAheadClick}
            focusRef={el => {
              skipBackRef = el;
            }}
          />
        </HeadContainer>
        {count ? (
          <Swimlane
            renderItem={renderPromotion}
            averageItemWidth={getAverageItemWidth()}
            itemCount={count}
            onScroll={handleScroll}
          />
        ) : (
          <LoadingBlock>
            <CenteredSpinner />
          </LoadingBlock>
        )}

        <AccessibleSkipButton
          focusRef={el => {
            skipAheadRef = el;
          }}
          skipClick={skipBackClick}
          label={t("base.skip-back", "Skip Back")}
          top={-25}
          left={35}
        />
      </Container>
    );
  }
  return null;
}


const mapStateToProps = state => ({
  promotions: bridgeSelectors.getPromotions(state)
});

export default connect(
  mapStateToProps,
  null
)(withAllMatches(PromotionSwimlane));
